// extracted by mini-css-extract-plugin
module.exports = {"btns":"btns-4bae6a9163bfdeac42aa339bf1258511"};